import apiClient, {authHeader, handleError} from "@/helpers/ApiClient";

export const deviceService = {
    getDeviceData,
    deleteDevice,
    deleteAllDevice
}

function getDeviceData() {
    return apiClient.get(`/device`, {headers: authHeader()})
        .then((response) => {
            return response.data
        })
        .catch((error) => handleError(error));
}

function deleteDevice(device) {
    return apiClient.delete(`/device/${device.serialNumber}`, {headers: authHeader()})
        .then((response) => {
            return response.data;
        })
        .catch((error) => handleError(error));
}

function deleteAllDevice() {
    return apiClient.delete(`/device`, {headers: authHeader()})
        .then((response) => {
            return response.data;
        })
        .catch((error) => handleError(error));
}